export default function About(props) {
  return (
    <article id="foretaget" className="invert">
      <section>
        <h2  id="about_title">Om företaget</h2>
        <p>
          <strong>Mureri & Eldstäder i Söderhamn AB</strong><br />
          Org. nr: 559448 - 8701<br/>
          Grundviksvägen 41<br/>
          826 60 Söderhamn
        </p>
        <p>
          Fakturaadress: <a href="mailto:faktura@mureriocheldstader.se">faktura@mureriocheldstader.se</a>
        </p>
        <p>
          <strong>Daniel Haglund</strong><br/>
          Tel: 070-214 84 48<br/>
          E-post: <a href="mailto:daniel@mureriocheldstader.se">daniel@mureriocheldstader.se</a>
        </p>

      </section>
    </article>
  )
}
// Compare this snippet from src/components/Referenser.js: